export default {
  head: ({ opened, isSafari, isApp, isOverlapMenuMobileView, headerStyles = {} }) => ({
    px: 2,
    width: '100%',
    pt: isApp ? '10px' : '5px',
    pb: isApp ? '5px' : 0,
    height: isApp ? 120 : 65,
    top: 0,
    bgcolor: opened ? 'background.default' : 'background.paper', // TODO - move to theme pallete
    display: 'flex',
    alignItems: 'center',
    flexDirection: isApp ? 'column' : 'row',
    justifyContent: isApp ? 'space-around' : 'space-between',
    zIndex: isOverlapMenuMobileView ? 1000 : 1200,
    position: isSafari ? '-webkit-sticky' : 'sticky',
    ...headerStyles,
  }),
  headButton: ({ palette }) => ({
    color: palette.text.primary,
  }),
  navBar: {
    py: 1,
    pb: '12px',
    width: '100%',
    height: '65px',
    bottom: '-5px',
    zIndex: 1300,
    position: 'fixed',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    bgcolor: 'background.default',
  },
  navButton:
    ({ selected, isApp }) =>
    ({ palette }) => ({
      maxWidth: isApp ? '16.5vw' : '18vw',
      minWidth: isApp ? '16.5vw' : '18vw',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexDirection: 'column',
      position: 'relative',
      textAlign: 'center',
      color: selected ? palette.primary.main : palette.text.primary,
      '& svg': {
        flex: 1,
        fill: selected ? palette.primary.main : palette.text.primary,
      },
      '& p': {
        mt: 0.5,
        fontSize: 12,
        fontWeight: 600,
      },
    }),
  drawerPaper: {
    pt: '80px',
    pb: '120px',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    bgcolor: 'background.default',
    overflowX: 'auto',
  },
  drawer: { zIndex: 1100, pt: '70px' },
  menuItems: {
    mt: 1,
    px: 1,
    flex: 1,
    width: '100%',
    justifyContent: 'space-between',
    overflowX: 'auto',
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    '&::-webkit-scrollbar': { display: 'none' },
  },
  button: ({ selected, showIcon }) => ({ palette }) => ({
    px: 2,
    height: showIcon ? 50:38,
    fontSize: 12,
    padding: 0,
    minWidth: 'fit-content',
    whiteSpace: 'nowrap',
    fontWeight: selected ? 700 : 600,
    color: selected ? palette.primary.main : palette.text.primary,
    '& svg': {
      fill: selected ? palette.primary.main : palette.text.primary,
    },
    ...(showIcon && {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 0.5,
    }),
  })

};
